import { useEffect, useState } from "react";
import Search from "./Search";
import { BeatLoader, RiseLoader } from "react-spinners";

export default function SearchWrapper(){
    const [movieName, setMovieName] = useState("");
    const [recentComponent, setRecentComponent] = useState(null);
    const [selectedMovie, setSelectedMovie] = useState("");
    const [recommendationComponent, setRecommendationComponent] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    let movieTitle = selectedMovie !== "" ? selectedMovie : movieName;

    function searchMovie(event){
        setSelectedMovie("");
        setMovieName(event.target.value);
    }

    useEffect(() => {
        if(movieName.length > 3 && selectedMovie === ""){
            setRecentComponent(<Search movieName={movieName} setIsLoading={setIsLoading} setSelectedMovie={setSelectedMovie} setRecommendationComponent={setRecommendationComponent} />);
        } else {
            setRecentComponent(null);
        }


    }, [movieName, selectedMovie, isLoading]);
    
    return (
        <div className="search-wrapper">
            <div className="search-container">
                <span className="text-center title">Movie Recommendations</span>
                <span className="mb-4 text-center title big">Like This Movie</span>
            
                <input type="text" className="form-control search-input" placeholder="Enter a movie name..." value={movieTitle} onChange={searchMovie} />
                <i className="bi bi-search position-absolute top-50 end-0 translate-middle-y me-3"></i>
            
                {recentComponent}

                {isLoading ? <RiseLoader color="#fff" size={30} className="beat-loader" /> : null}

                {recommendationComponent}
            </div>
        </div>
    )
} 